import {Inject, Injectable} from '@angular/core';
import {OAuthEvent, OAuthService} from 'angular-oauth2-oidc';
import { HttpHeaders, HttpClient } from '@angular/common/http';
import {environment, CustomEnvironment, setApiOverrides} from '../../environments/environment';
import {Observable} from 'rxjs';
import {catchError, tap} from 'rxjs/operators';
import {HttpErrorHandlerService, HandleError} from './http-error-handling.service';

const httpOptions = {
  headers: new HttpHeaders({
    'Content-Type': 'application/json',
    'Authorization': 'my-auth-token',
    'x-banking-sys': 'u'
  })
};

@Injectable()
export class BankingService {
  private handleError: HandleError;

  constructor(private oauthService: OAuthService,
              private http: HttpClient,
              httpErrorHandler: HttpErrorHandlerService,
              @Inject(CustomEnvironment) customEnvironment: any) {
    setApiOverrides(customEnvironment);

    this.oauthService.events.subscribe((event: OAuthEvent) => {
      const tokenUpdatedEvents = ['token_refreshed', 'token_received', 'silently_refreshed'];
      if (tokenUpdatedEvents.includes(event.type)) {
        httpOptions.headers = httpOptions.headers.set('Authorization', this.oauthService.authorizationHeader());
      }
    });

    httpOptions.headers = httpOptions.headers.set('Authorization', this.oauthService.authorizationHeader());
    this.handleError = httpErrorHandler.createHandleError('ProductService');
  }
  

  searchBillerCode(type, code): Observable<any> {
    return this.http.get<any[]>(`${environment.api.banking}/operator/billers/${type}/${code}`, httpOptions);
  }
}
